import { useState } from 'react'
import { Button, MergeIcon } from '@quickmd-llc/design-system'
import { useMergeAccounts } from './context/useMergeAccounts'
import { MergeAccountsPopup } from './MergeAccountsPopup/MergeAccountsPopup'

export function MergeAccountsButton() {
  const { selectedPatients } = useMergeAccounts()
  const [visible, setVisible] = useState<boolean>(false)

  return (
    <>
      {visible ?
        <MergeAccountsPopup onClose={() => setVisible(false)} />
      : null}

      <Button disabled={selectedPatients.length < 2} onClick={() => setVisible(true)}>
        <MergeIcon />
        Merge accounts
      </Button>
    </>
  )
}
